import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=b0b16752&scoped=true&"
import script from "./NavigationBar.vue?vue&type=script&lang=ts&"
export * from "./NavigationBar.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationBar.vue?vue&type=style&index=0&id=b0b16752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b16752",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAppBar,VCol,VMenu,VRow,VSheet})
